import { addYears } from 'date-fns'

export default {
  name: 'project_start_date',
  component_path: 'modules/procedures/blocks/BlockInputDate',
  static_options: {
    open_date: new Date(),
    show_time: true,
    available_dates: {
      start: new Date(),
      end: addYears(new Date(), 10)
    }
  },
  static_mandatory: ['required', `maxDate:${addYears(new Date(), 10).toISOString()}`],
  default_value: 'default_values.project.start_date'
}